<template>
    <section id="about-visit" class="blog-details article">
        <article class="article">
            <h2 class="title mb-2">Preparing for Your Visit</h2>

            <div class="content mt-2">
                <div class="row g-2">
                    <div class="col-lg-6">
                        <div class="card h-100 border-0 shadow-sm p-3 bg-light bg-opacity-75">
                            <h3 class="text-center mb-2 mt-0">Before Your Visit</h3>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Drink plenty of water <strong>days before</strong> your visit</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Use a basic <strong>moisturizer</strong> on treatment areas</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Arrive with <strong>clean skin</strong></li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">No <strong>makeup</strong> or deodorant in treatment areas</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Stop <strong>harsh skincare</strong> products one week prior</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Skip <strong>caffeine/alcohol</strong> before treatment</li>
                                
                                <li class="list-group-item ps-0 bg-transparent">Consult physician if pregnant or have <strong>medical conditions</strong></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="card h-100 border-0 shadow-sm p-3 bg-light bg-opacity-75">
                            <h3 class="text-center mb-2 mt-0">After Your Visit</h3>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Apply a <strong>cold compress</strong> to soothe treated areas</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Avoid <strong>sun exposure</strong> for 48 hours after treatment</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Let <strong>scabs heal</strong> naturally without picking</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">Skip <strong>active skincare</strong> for 48 hours after facial treatment</li>
                                
                                <li class="list-group-item border-bottom border-opacity-15 ps-0 bg-transparent">No <strong>deodorant</strong> for 24 hours after underarm treatment</li>
                                
                                <li class="list-group-item ps-0 bg-transparent">Only use <strong>scissors or shaving</strong> between treatments, <strong>never pluck or wax</strong></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </section>
</template>

<script>
export default {
    name: 'AboutVisit'
}
</script> 